// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-view {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 24px;
  right: 0;
}
.main-view img {
  max-width: 100%;
  height: auto;
}

.mt-0 {
  margin-top: 0;
}

.mb-0 {
  margin-bottom: 0;
}

.ml-0 {
  margin-left: 0;
}

.mr-0 {
  margin-right: 0;
}

@media (min-width: 768px) {
  .center-height {
    height: calc(100vh - 48px - 24px - 66px);
  }
}

.navbar-menu-item .counter {
  left: auto;
  right: -0.3em;
  top: -0.5em;
  position: absolute;
}

.no-sidebar {
  left: 0;
}

.has-padding {
  padding: 10px;
}
.has-padding.dashboard-page {
  padding-top: 68px;
}

.async-select {
  color: #000;
}

.visible-responsive {
  display: none !important;
}

.recharts-default-tooltip {
  background: #fff;
  color: #222;
  min-width: 150px;
  padding: 10px;
  border-radius: 4px;
}

.full-height-container {
  height: 100vh;
  min-height: 100%;
}

.leaflet-container.chat-map-container {
  height: 100%;
  min-height: inherit;
}

.ticker__element .ticker-inner {
  display: flex;
  white-space: nowrap;
  padding-left: 100px;
}

.MuiListSubheader-root {
  line-height: 30px !important;
  border-top: 1px solid;
}

.maintenance-motion-list {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  row-gap: 0;
}
.maintenance-motion-list .motion-status-bar {
  flex: 1 1;
}

@media (max-width: 959px) {
  .fms-sidebar-wrapper,
  .fms-sidebar-wrapper .fms-sidebar {
    width: 306px;
    left: -306px;
  }
  .sidebar-dragicon {
    display: none;
  }
  .sidebar-collapse .sidebar-dragicon {
    display: block;
  }
  .sidebar-collapse .fms-sidebar-wrapper,
  .sidebar-collapse .fms-sidebar-wrapper .fms-sidebar {
    left: 0;
  }
  .sidebar-devices-list,
  .scrollable-sidebar {
    margin-right: 0;
  }
  .fms-header {
    left: 0;
  }
  .hidden-responsive {
    display: none !important;
  }
  .visible-responsive {
    display: block !important;
  }
}
@media (max-width: 599px) {
  .fms-sidebar-wrapper {
    top: 0;
    bottom: 0;
    background: #fff;
  }
  /* .fms-sidebar-wrapper,
  .fms-sidebar {
    width: 100%;
    left: -100%;
    border-radius: 0;
  } */
  .sidebar-devices-list {
    height: calc(100vh - 66px - 54px - 10px - 24px);
  }
  .sidebar-dragicon {
    display: none;
  }
  .sidebar-collapse .sidebar-dragicon {
    display: block;
  }
  .main-view {
    box-sizing: border-box;
    position: relative;
    top: 49px;
    height: calc(100vh - 49px - 24px);
    z-index: 0;
  }
  .main-view .main-view {
    position: absolute;
    top: 0;
    bottom: 0;
    overflow: auto;
  }
  .daterangepicker .drp-selected {
    padding-right: 0;
  }
  .daterangepicker .ranges,
  .daterangepicker .drp-calendar {
    float: none;
  }
  .daterangepicker .ranges ul {
    width: auto;
  }
  .ScrollbarsCustom-Wrapper {
    right: 0 !important;
  }
}
@media (max-width: 499px) {
  .main-view {
    bottom: 28px;
  }
}
.v-filter-field {
  color: #0a83a1;
  border: 1px solid;
  display: block;
  width: 100%;
  padding: 1px 14px;
  font-size: 12px;
  border-radius: 4px;
  box-sizing: border-box;
}

.v-filter-field2 {
  display: flex;
  gap: 10px;
  align-items: center;
}
.v-filter-field2 .async-select {
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/Layout/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YCkBa;EDhBb,QAAA;AAFF;AAIE;EACE,eAAA;EACA,YAAA;AAFJ;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAOE;EADF;IAEI,wCAAA;EAHF;AACF;;AAMA;EACE,UAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;AAHF;;AAMA;EACE,OAAA;AAHF;;AAMA;EAEE,aAAA;AAJF;AAKE;EACE,iBAAA;AAHJ;;AAOA;EACE,WAAA;AAJF;;AAOA;EACE,wBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AAJF;;AAOA;EACE,aAAA;EACA,gBAAA;AAJF;;AAOA;EACE,YAAA;EACA,mBAAA;AAJF;;AAQE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AALJ;;AASA;EACE,4BAAA;EACA,qBAAA;AANF;;AASA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;AANF;AAOE;EACE,SAAA;AALJ;;AAWA;EAEE;;IAEE,YC9FY;ID+FZ,YAAA;EATF;EAYA;IACE,aAAA;EAVF;EAaA;IACE,cAAA;EAXF;EAgBE;;IAEE,OAAA;EAdJ;EAkBA;;IAEE,eAAA;EAhBF;EAmBA;IACE,OAAA;EAjBF;EAoBA;IACE,wBAAA;EAlBF;EAqBA;IACE,yBAAA;EAnBF;AACF;AAsBA;EAEE;IACE,MAAA;IACA,SAAA;IACA,gBAAA;EArBF;EAwBA;;;;;KAAA;EAMA;IACE,+CAAA;EAtBF;EAyBA;IACE,aAAA;EAvBF;EA0BA;IACE,cAAA;EAxBF;EA2BA;IACE,sBAAA;IACA,kBAAA;IACA,SCxJK;IDyJL,iCAAA;IACA,UAAA;EAzBF;EA4BA;IACE,kBAAA;IACA,MAAA;IACA,SAAA;IACA,cAAA;EA1BF;EA6BA;IACE,gBAAA;EA3BF;EA8BA;;IAEE,WAAA;EA5BF;EA+BA;IACE,WAAA;EA7BF;EAgCA;IACE,mBAAA;EA9BF;AACF;AAiCA;EACE;IACE,YAAA;EA/BF;AACF;AAkCA;EACE,cAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAhCF;AAiCE;EACE,SAAA;AA/BJ","sourcesContent":["@import './../assets/variables';\n\n.main-view {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: $footerHeight;\n  //overflow: auto;\n  right: 0;\n\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n.mt-0 {\n  margin-top: 0;\n}\n\n.mb-0 {\n  margin-bottom: 0;\n}\n\n.ml-0 {\n  margin-left: 0;\n}\n\n.mr-0 {\n  margin-right: 0;\n}\n\n.center-height {\n  @media (min-width: 768px) {\n    height: calc(100vh - #{$headerHeight} - #{$footerHeight} - 66px);\n  }\n}\n\n.navbar-menu-item .counter {\n  left: auto;\n  right: -0.3em;\n  top: -0.5em;\n  position: absolute;\n}\n\n.no-sidebar {\n  left: 0;\n}\n\n.has-padding {\n  //overflow: auto;\n  padding: 10px;\n  &.dashboard-page {\n    padding-top: $headerHeight + 20px;\n  }\n}\n\n.async-select {\n  color: #000;\n}\n\n.visible-responsive {\n  display: none !important;\n}\n\n.recharts-default-tooltip {\n  background: #fff;\n  color: #222;\n  min-width: 150px;\n  padding: 10px;\n  border-radius: 4px;\n}\n\n.full-height-container {\n  height: 100vh;\n  min-height: 100%;\n}\n\n.leaflet-container.chat-map-container {\n  height: 100%;\n  min-height: inherit;\n}\n\n.ticker__element {\n  .ticker-inner {\n    display: flex;\n    white-space: nowrap;\n    padding-left: 100px;\n  }\n}\n\n.MuiListSubheader-root {\n  line-height: 30px !important;\n  border-top: 1px solid;\n}\n\n.maintenance-motion-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  row-gap: 0;\n  .motion-status-bar {\n    flex: 1;\n  }\n}\n\n// responsive\n\n@media (max-width: 959px) {\n\n  .fms-sidebar-wrapper,\n  .fms-sidebar-wrapper .fms-sidebar {\n    width: $sidebarWidthResponsive;\n    left: -$sidebarWidthResponsive;\n  }\n\n  .sidebar-dragicon {\n    display: none;\n  }\n\n  .sidebar-collapse .sidebar-dragicon {\n    display: block;\n  }\n\n  .sidebar-collapse {\n\n    .fms-sidebar-wrapper,\n    .fms-sidebar-wrapper .fms-sidebar {\n      left: 0;\n    }\n  }\n\n  .sidebar-devices-list,\n  .scrollable-sidebar {\n    margin-right: 0;\n  }\n\n  .fms-header {\n    left: 0;\n  }\n\n  .hidden-responsive {\n    display: none !important;\n  }\n\n  .visible-responsive {\n    display: block !important;\n  }\n}\n\n@media (max-width: 599px) {\n\n  .fms-sidebar-wrapper {\n    top: 0;\n    bottom: 0;\n    background: #fff;\n  }\n\n  /* .fms-sidebar-wrapper,\n  .fms-sidebar {\n    width: 100%;\n    left: -100%;\n    border-radius: 0;\n  } */\n  .sidebar-devices-list {\n    height: calc(100vh - 66px - 54px - 10px - #{$footerHeight});\n  }\n\n  .sidebar-dragicon {\n    display: none;\n  }\n\n  .sidebar-collapse .sidebar-dragicon {\n    display: block;\n  }\n\n  .main-view {\n    box-sizing: border-box;\n    position: relative;\n    top: $topGap;\n    height: calc(100vh - #{$topGap} - #{$footerHeight});\n    z-index: 0;\n  }\n\n  .main-view .main-view {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    overflow: auto;\n  }\n\n  .daterangepicker .drp-selected {\n    padding-right: 0;\n  }\n\n  .daterangepicker .ranges,\n  .daterangepicker .drp-calendar {\n    float: none;\n  }\n\n  .daterangepicker .ranges ul {\n    width: auto;\n  }\n\n  .ScrollbarsCustom-Wrapper {\n    right: 0 !important;\n  }\n}\n\n@media (max-width: 499px) {\n  .main-view {\n    bottom: 28px;\n  }\n}\n\n.v-filter-field {\n  color: #0a83a1;\n  border: 1px solid;\n  display: block;\n  width: 100%;\n  padding: 1px 14px;\n  font-size: 12px;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.v-filter-field2 {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  .async-select {\n    flex: 1;\n  }\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$filterColWidth: 72px;\n$sidebarWidth : 306px;\n$sidebarMaintenanceWidth: $sidebarWidth + 131px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 44px;\n$headerNavWidth: 150px;\n$headerHeight: 48px;\n$footerHeight: 24px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 1;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: transparent;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #ffffff;\n$lightGrey: #b7b7b7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 99999;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Inter, sans-serif;\n$altFontFamily: 'Bebas Neue', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
